import { EVENT_TYPES } from '../component/MatomoTagManger/MatomoTagManager.events';
import { pushEvent } from '../store/Matomo/Matomo.action';

const componentDidUpdate = (args, callback, instance) => {
    const [prevProps] = args;
    const { cartTotals: { items_qty: prevItemsQty } = {} } = prevProps;
    const { cartTotals: { items, grand_total, items_qty } = {}, pushEvent } = instance.props;

    if (prevItemsQty !== items_qty && (prevItemsQty !== -1 && items_qty !== 0)) {
        pushEvent(EVENT_TYPES.CART_UPDATE, { items, items_qty });
        pushEvent(EVENT_TYPES.CART_TOTAL, { grand_total });
    }

    return callback.apply(instance, args);
};

const mapDispatchToProps = (args, callback) => {
    const [dispatch] = args;

    return {
        ...callback(...args),
        pushEvent: (event, data) => {
            dispatch(pushEvent(event, data));
        }
    };
};

export default {
    'Component/Header/Container': {
        'member-function': {
            componentDidUpdate,
            mapDispatchToProps
        }
    },
    'Component/Header/Container/mapDispatchToProps': {
        function: mapDispatchToProps
    }
};
